import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import identity from 'transmute/identity';
import { InMemoryCache } from '../InMemoryCache';
const fetchMultiCurrency = (__unusedKey, httpClient) => {
  return getFrameworkDataSchemasClient({
    httpClient
  }).then(client => client.multiCurrency.get());
};
export const makeMultiCurrencyCache = () => {
  return new InMemoryCache('multiCurrency', identity, ({
    httpClient
  }) => key => fetchMultiCurrency(key, httpClient));
};